import { render, staticRenderFns } from "./ForecastUONote.vue?vue&type=template&id=64abe887&"
import script from "./ForecastUONote.vue?vue&type=script&lang=js&"
export * from "./ForecastUONote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports